import { useCallback, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { buyCardApi } from 'redux/api/buy-card.api'
import { statusApi, useGetStatusQuery } from 'redux/api/status.api'
import { setIsBuyLanding } from 'redux/store/slices/application-slice'
import { setError } from 'redux/store/slices/error-slice'
import { pathnames } from 'utils/steps'

const useCheckStatus = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const [currentStep, setCurrentStep] = useState('')
  const [statusData, setStatusData] = useState(null)
  const { t } = useTranslation()

  useEffect(() => {
    if (statusData?.step && statusData?.step !== currentStep) {
      statusData.status === 'CANCELED' && dispatch(setError({ code: statusData?.status, description: '' }))
      setCurrentStep(statusData?.step)
      switch (statusData?.step) {
        case 'PAYMENT':
          navigate(pathnames.pending)
          break
        case 'COLVIR':
          statusData.status === 'IN_PROGRESS' && navigate(pathnames.pending)
          if (statusData.pan_card) {
            dispatch(setIsBuyLanding(true))
            navigate(pathnames['personal-cabinet'])
            return
          }
          break
        default:
          break
      }
    }
  }, [navigate, statusData, currentStep])

  const checkStatus = useCallback(() => {
    dispatch(statusApi.endpoints.getStatus.initiate(null, { forceRefetch: true }))
      .unwrap()
      .then(res => {
        setStatusData(res.data)
      })
  }, [])

  return [checkStatus]
}

export default useCheckStatus
